import { render, staticRenderFns } from "./tier_badge.vue?vue&type=template&id=e3bda33a&vue3"
import script from "./tier_badge.vue?vue&type=script&lang=js&vue3"
export * from "./tier_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports